const setFixedOffset = (() => {
	function init() {
		window.addEventListener('DOMContentLoaded', () => {
			setHeight();
		});
	}

	function setHeight() {
		const header = document.querySelector('.header');
		document.documentElement.style.setProperty('--offset', `${ header.offsetHeight }px`);
	}

	return {
		init,
	};
})();

export default setFixedOffset;